import React, { Component } from 'react';
import { connect } from 'react-redux';
import { navigate } from '../modules/high_level_actions';
import { detachCustomer } from '../modules/customer';
import { placeNonClubOneTimePayment, getNonClubAccountBalance } from '../modules/onetime_payment_success';
import NonClubBraintreeDropin  from './NonClubBraintreeDropin.jsx';

class NonClubMakePayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sap_account_number: '',
      pendingRetreive: false,
      payType: 'full',
      getCustomerInfoView: true,
      paymentAmount: 0
    }

    this.additionalParams = { amount: 0, sap_account_number: '' };
    this.handleAccountNumberChange = this.handleAccountNumberChange.bind(this);
    this.handlePayAmountChange  = this.handlePayAmountChange.bind(this);
    this.handleBlur             = this.handleBlur.bind(this);
    this.handlePayTypeChange    = this.handlePayTypeChange.bind(this);
    this.changeAccount          = this.changeAccount.bind(this);
    this.retrieveAccount        = this.retrieveAccount.bind(this);
  }

  componentWillReceiveProps(nextProps){
    if(this.props.customer != nextProps.customer && nextProps.customer.sap_account_number){
      this.additionalParams = { amount: nextProps.customer.balance, sap_account_number: nextProps.customer.sap_account_number };
      this.setState({
        sap_account_number: nextProps.customer.sap_account_number,
        pendingRetreive: false,
        paymentAmount: nextProps.customer.balance
      });
    } if(this.props.loginError != nextProps.loginError && nextProps.loginError )
      this.setState({ pendingRetreive: false });
  }

  handlePayTypeChange(evt) {
    let input = evt.currentTarget;
    let nPartialVal = 0;
    // Reset paymentAmount to full balance if full is selected
    if (input.value === 'full') {
      this.setState({
        payType: 'full',
        paymentAmount: this.props.customer.balance
      });
      this.additionalParams.amount = this.props.customer.balance;
    }
    // Get current value of partial entry field if partial is selected
    if (input.value === 'partial') {
      nPartialVal = document.getElementById('partial-pay-amount').value;
      if (parseFloat(nPartialVal).toFixed(2) > this.props.customer.balance){
        nPartialVal = self.props.customer.balance;
      }
      this.setState({
        payType: 'partial',
        paymentAmount: nPartialVal
      });
      this.additionalParams.amount = nPartialVal;
    }
  }

  handlePayAmountChange(evt) {
    let self  = this;
    let value = evt.currentTarget.value;
    // Only update if entry is a number
    if (!isNaN(value)){
      if (parseFloat(value).toFixed(2) > self.props.customer.balance){
        value = self.props.customer.balance;
      }
      self.setState({ paymentAmount: value });
      self.additionalParams.amount = value;
    }

  }

  retrieveAccount(evt){
    evt.preventDefault();
    this.props.dispatch( getNonClubAccountBalance(this.state.sap_account_number));
    this.setState({ getCustomerInfoView: false, pendingRetreive: true });
  }

  changeAccount(){
    this.setState({ getCustomerInfoView: true });
    this.props.dispatch(detachCustomer());
  }

  handleAccountNumberChange(evt){
    let self  = this;
    let value = evt.currentTarget.value;

    self.setState({ sap_account_number: value });
    self.additionalParams.sap_account_number = value;
  }

  handleBlur(evt){
    // Clean up entry on blur
    let self        = this;
    let {dispatch}  = this.props;
    let prettyValue = parseFloat(self.state.paymentAmount).toFixed(2);
    self.setState({ paymentAmount: prettyValue });
    self.additionalParams.amount = prettyValue;
  }


  render() {
    let { store, dispatch, customer, loginError, onetimePaymentSuccess, feedback } = this.props;
    let { sap_account_number, payType, getCustomerInfoView, paymentAmount, pendingRetreive } = this.state;

    let paymentObj = <div />;
    let customerObj = (
      <div className="retrieveAccount">
        <form onSubmit={this.retrieveAccount.bind(this)}>
        <div className={"errorMessage" + (loginError ? '' : 'hidden')}>
          <p>{loginError}</p>
        </div>
        <h3>Enter your account information: </h3>

         <input
          type         = "text"
          id           = "sap-account-number"
          name         = "sap-account-number"
          value        = {sap_account_number}
          placeholder  = "Account Number"
          onChange     = {this.handleAccountNumberChange} />

        <button className="btn-primary" disabled={pendingRetreive}>
          { pendingRetreive? "PENDING..." : "RETRIEVE ACCOUNT"}
        </button>
        </form>
      </div>
    );

    if(!getCustomerInfoView && customer && !isNaN(customer.balance) ){
      let nBalance     = parseFloat(customer.balance).toFixed(2);
      let balanceText  = (<h4 className="blocked">Your full balance: ${nBalance}</h4>);

      if(onetimePaymentSuccess === true)
        balanceText = (<h4 className="blocked">Thank you for your payment. Your new balance is ${nBalance}</h4>);
      else if (nBalance <= 0) balanceText = (<h4 className="blocked">Congratulations! Your balance is $0.00.</h4>);

      customerObj = (
        <div className="accountInfo">
          <h4>Account Number:</h4>
          <input className="inline-input" value={customer.sap_account_number} disabled />
          <button
            className="btn-secondary"
            onClick={this.changeAccount.bind(this)} >
            CHANGE ACCOUNT
          </button>
          {balanceText}
        </div>
      );

      if(customer.balance > 0)
        paymentObj = (
          <div className="bordered-box">
            <div className={"errorMessage" + (feedback ? '' : ' hidden')}>
              <p>{feedback}</p>
            </div>
            <div className="half-col left">
              <h4 className="alt">I want to pay:</h4>
              <div className="form-otp-container">
                <input
                  type     = "radio"
                  id       = "full-pay"
                  name     = "pay-type"
                  value    = "full"
                  checked  = {this.state.payType === 'full'}
                  onChange = {this.handlePayTypeChange}
                />
                <label htmlFor="full-pay">My full balance: ${nBalance}</label>
              </div>
              <div className="form-otp-container">
                <input
                  type     = "radio"
                  id       = "partial-pay"
                  name     = "pay-type"
                  value    = "partial"
                  checked  = {this.state.payType === 'partial'}
                  onChange = {this.handlePayTypeChange}
                />
                <label htmlFor="partial-pay">Part of my balance: $</label>
                <input
                  step         = "0.01"
                  type         = "number"
                  id           = "partial-pay-amount"
                  name         = "partial-amount"
                  value        = {this.state.paymentAmount}
                  placeholder  = {nBalance}
                  min          = "1.00"
                  max          = {nBalance}
                  onChange     = {this.handlePayAmountChange}
                  onBlur       = {this.handleBlur}
                  disabled     = {this.state.payType !== 'partial'}
                />
              </div>
            </div>

            <div className="half-col">
              <h4 className="alt">Pay with:</h4>
                <NonClubBraintreeDropin
                  submitFunction = {placeNonClubOneTimePayment}
                  additionalParams = {this.additionalParams}
                  uniqueContainer = "make-payment-form" />
            </div>
          </div>
        );
    }

    return (
      <div className="content-max-width payment">
        <div className="header-menu">
          <a href="/" onClick={(evt) => dispatch( navigate(evt))} className="logo">
            <img src={'/images/' + store.tla.toLowerCase() + '/logo.png'} />
          </a>
        </div>
        <div className="inner-wrapper">
          <h2>Make a Payment</h2>
          {customerObj}
        </div>
        {paymentObj}
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'store': state.store,
      'loginError': state.loginError,
      'customer': state.customer,
      'feedback': state.feedback,
      'onetimePaymentSuccess': state.onetimePaymentSuccess
    };
}

export default connect(mapStateToProps)(NonClubMakePayment);


// WEBPACK FOOTER //
// ./src/components/NonClubMakePayment.jsx